module.exports = __webpack_public_path__ + "static/img/apply.9ea08558.png";